import { CommonActions, StackActions, createNavigationContainerRef, } from '@react-navigation/native';
export const goBackWithKey = (navigation, keyBack, goToPreviousRoute = true) => {
    if (keyBack) {
        const { routes } = navigation.getState();
        if (routes?.length) {
            const routeIndex = routes.findIndex((route) => route.key === keyBack);
            if (routeIndex < 0) {
                return false;
            }
            const previousRoute = routes[routeIndex - 1];
            if (previousRoute === undefined || !goToPreviousRoute) {
                // @ts-ignore
                navigation.navigateDeprecated(routes[routeIndex].name, routes[routeIndex].params);
                return true;
            }
            // @ts-ignore
            navigation.navigateDeprecated(previousRoute.name, previousRoute.params);
            return true;
        }
    }
    return false;
};
export const navigationRef = createNavigationContainerRef();
export function navigate(screenName, params) {
    if (navigationRef.isReady()) {
        navigationRef.dispatch(StackActions.push(screenName, params));
    }
}
export function popToTop(onSuccess) {
    if (navigationRef.isReady()) {
        if (navigationRef.canGoBack()) {
            navigationRef.dispatch(StackActions.popToTop());
        }
        onSuccess?.();
    }
}
export const goBack = () => {
    if (navigationRef.isReady()) {
        navigationRef.dispatch(CommonActions.goBack());
    }
};
export function goBackToTopWithStops(navigation, stopAt) {
    const { routes } = navigation.getState();
    for (const name of stopAt) {
        const route = routes.findLast((route) => route.name === name);
        if (route) {
            // @ts-ignore - a route taken from state is valid
            navigation.popTo(route.name, route.params);
            return;
        }
    }
    if (navigation.canGoBack()) {
        navigation.popToTop();
    }
}
// If `screen` is already in the stack, pop back to it (preserving its existing
// params via merge); otherwise push it as a new screen. Mirrors the v6
// `navigate` semantics that v7 dropped.
export function popToOrNavigate(navigation, screen, params) {
    const { routes } = navigation.getState();
    const isInStack = routes.some((r) => r.name === screen);
    if (isInStack) {
        // @ts-ignore - generic params are valid for the matched route
        navigation.popTo(screen, params, { merge: true });
    }
    else {
        // @ts-ignore - generic params are valid for the named screen
        navigation.navigate(screen, params);
    }
}
